import { getDenormalizedDataEntitiesByIds } from '../../redux/entities/selectors';
import { galleryFolderSchema } from '../../redux/normalizr/schemas/folder';
import { reduxKey } from './constants';
export const getIsReduxModuleReady = (state)=>{
    var _state_reduxKey;
    return state === null || state === void 0 ? void 0 : (_state_reduxKey = state[reduxKey]) === null || _state_reduxKey === void 0 ? void 0 : _state_reduxKey.reduxReady;
};
export const getGallectionIds = (state, groupid, type)=>{
    var _state_reduxKey_gallections_groupid, _state_reduxKey_gallections, _state_reduxKey;
    return state === null || state === void 0 ? void 0 : (_state_reduxKey = state[reduxKey]) === null || _state_reduxKey === void 0 ? void 0 : (_state_reduxKey_gallections = _state_reduxKey.gallections) === null || _state_reduxKey_gallections === void 0 ? void 0 : (_state_reduxKey_gallections_groupid = _state_reduxKey_gallections[groupid]) === null || _state_reduxKey_gallections_groupid === void 0 ? void 0 : _state_reduxKey_gallections_groupid[type];
};
export const getGallections = (state, groupid, type)=>{
    const gallectionIds = getGallectionIds(state, groupid, type);
    return gallectionIds && getDenormalizedDataEntitiesByIds(state, galleryFolderSchema, gallectionIds);
};

//# sourceMappingURL=selectors.js.map